/* public/js/ielts-scorer/app.js — the /ielts-scorer page.
 *
 * One sheet of exam paper and one examiner's report beside it:
 *   - the sheet is a textarea over a mirror of its own text; the mirror carries
 *     the highlights (CSS Custom Highlight API where the browser has it, <mark>
 *     where it does not), so marking a word never touches what the person types;
 *   - the instant check (analyze.js) runs on every pause in typing, in the
 *     browser; the examiner grade (/api/ielts-scorer) is a server job;
 *   - every essay is a saved work (tool-draft-editor.js): a crash, F5 or a
 *     closed tab does not take 40 minutes of writing with it.
 *
 * Pairs with resources/views/tools/ielts-scorer.blade.php (window.IWCFG).
 */
(function () {
'use strict';

var CFG = window.IWCFG || {};
var T = CFG.i18n || {};
var root = document.getElementById('iw');
if (!root || !window.IeltsAnalyze) return;
var A = window.IeltsAnalyze;
var CH = window.IeltsCharts;
var SLUG = CFG.slug || 'ielts-scorer';
var LOCALE = CFG.lang || 'en';
var POLL_MS = 2000, POLL_MAX_MS = 4 * 60 * 1000, JOB_KEY = 'iw-job';
function $(id) { return document.getElementById(id); }

var el = {
    taskSeg: root.querySelector('.iw-tasks'), timerBox: $('iwTimer'), timerBtn: $('iwTimerBtn'), timerTxt: $('iwTimerTxt'),
    timerReset: $('iwTimerReset'), viewSeg: root.querySelector('.iw-views'), vBand: $('iwVBand'),
    q: $('iwQuestion'), qTag: $('iwQTag'), bankBtn: $('iwBankBtn'), randomBtn: $('iwRandomBtn'),
    chartBox: $('iwChartBox'), chartThumb: $('iwChartThumb'), chartTitle: $('iwChartTitle'), upl: $('iwUpl'),
    uplZone: $('iwChart'), chartNote: $('iwChartNote'),
    paper: $('iwPaper'), sheet: $('iwSheet'), hl: $('iwHl'), ta: $('iwEssay'), pop: $('iwPop'),
    meter: $('iwMeter'), ring: $('iwRingFg'), words: $('iwWords'), minW: $('iwMinW'), meterSub: $('iwMeterSub'), paras: $('iwParas'),
    go: $('iwGo'), goTxt: $('iwGoTxt'),
    sideHead: $('iwSideHead'), sideBody: $('iwSideBody'), sideFoot: $('iwSideFoot'),
    bank: $('iwBank'), bankFilters: $('iwBankFilters'), bankList: $('iwBankList'), chartDlg: $('iwChartDlg'), chartBig: $('iwChartBig'),
    pdfDoc: $('iwPdfDoc')
};

/* ═══ helpers ════════════════════════════════════════════════════════════ */
function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}
function plural(n, forms) { return A.plural(n, forms, LOCALE); }
function tpl(s, p) { return A.format(s, p, T.pl || {}, LOCALE); }
function t(k, p) { var v = T[k]; return v == null ? '' : (p ? tpl(v, p) : String(v)); }
function csrf() { var m = document.querySelector('meta[name="csrf-token"]'); return m ? m.getAttribute('content') : ''; }
function toast(m, type) { try { if (window.__toast) window.__toast(m, type || 'error'); } catch (e) {} }
function track(action, data) {
    try {
        var p = { slug: SLUG, action: action }, k;
        if (data) for (k in data) p[k] = data[k];
        if (window.__ae) window.__ae('feature_use', p);
    } catch (e) {}
}
function setting(k, fb) { try { return window.__toolSettings ? window.__toolSettings.load(SLUG, k, fb) : fb; } catch (e) { return fb; } }
function saveSetting(k, v) { try { if (window.__toolSettings) window.__toolSettings.save(SLUG, k, v); } catch (e) {} }
function isPro() { return !!(CFG.isPro || (window.__tierLimits && window.__tierLimits.is_pro)); }
function minWords(task) { return (task || S.task).indexOf('task1') === 0 ? 150 : 250; }
function examMinutes(task) { return (task || S.task) === 'task2' ? 40 : 20; }
function fmtClock(ms) {
    var s = Math.floor(Math.abs(ms) / 1000), m = Math.floor(s / 60);
    return m + ':' + ('0' + (s % 60)).slice(-2);
}
function fmtNum(x) { try { return Number(x).toLocaleString(LOCALE, { maximumFractionDigits: 1 }); } catch (e) { return String(x); } }
function fmtBand(b) { return (typeof b === 'number') ? b.toFixed(1) : String(b == null ? '—' : b); }
function bandColor(b) {
    b = Number(b) || 0;
    return b >= 7 ? 'var(--iw-green)' : b >= 6 ? 'var(--lg-accent)' : b >= 5 ? 'var(--iw-amber)' : 'var(--iw-red)';
}
function critKey(k, task) {
    if (k === 'task') return String(task || S.task).indexOf('task1') === 0 ? 'task_achievement' : 'task_response';
    return k;
}
function critName(k, task) { return t('crit_' + critKey(k, task)); }
function critShort(k, task) { var m = T.crit_short || {}; return m[critKey(k, task)] || k; }
var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';

/* ═══ state ══════════════════════════════════════════════════════════════ */
var S = {
    task: 'task2', qid: '', chart: null, upload: null,
    report: null, reportFor: '', reportQ: '', reportTask: '', reportAt: 0, history: [],
    ignore: {}, timer: { limit: 0, start: 0, acc: 0, run: false }
};
var view = { side: 'auto', tab: 'criteria', explEn: !!setting('explEn', false), hl: setting('hl', true) !== false, view: 'write', openCrit: {} };
var analysis = null;
var busy = null;          // {job, t0, iv}
var example = null;       // {data, saved}
var offerData = null;     // server's needs_premium answer
var paid = null;          // a bought grade the page is waiting for: {kind:'pending'|'failed', ref, token}
var order = null;         // the essay saved for a one-off purchase: {ref, token, sig}
var ORDER_KEY = 'iw-order';
var focus = null;         // {ranges:[[s,e]], kind:'focus'|'quote', key}
var ed = null;            // drafts controller
var bank = null, bankP = null, bankFilter = 'all';
var dictP = null;

S.ignore = (function () { var o = Object.create(null), l = setting('ignore', []); (Array.isArray(l) ? l : []).forEach(function (w) { o[w] = 1; }); return o; })();
root.setAttribute('data-hl', view.hl ? 'on' : 'off');

/* ═══ task ═══════════════════════════════════════════════════════════════ */
function setTask(task, quiet) {
    if (['task2', 'task1_academic', 'task1_gt'].indexOf(task) < 0) task = 'task2';
    var changed = task !== S.task;
    S.task = task;
    root.setAttribute('data-task', task);
    el.taskSeg.querySelectorAll('[data-task]').forEach(function (b) {
        var on = b.getAttribute('data-task') === task;
        b.classList.toggle('on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    el.ta.placeholder = t('essay_ph_' + task) || t('essay_ph');
    el.minW.textContent = minWords(task);
    if (changed && S.qid && bankTaskOf(S.qid) !== task) { S.qid = ''; S.chart = null; }
    renderChart();
    renderTimer();
    if (!quiet) { track('task', { task: task }); touch(); }
    updateMeter();
    scheduleAnalysis(0);
}
el.taskSeg.addEventListener('click', function (e) {
    var b = e.target.closest('[data-task]');
    if (!b || example) return;
    setTask(b.getAttribute('data-task'));
});
el.taskSeg.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var bs = [].slice.call(el.taskSeg.querySelectorAll('[data-task]'));
    var i = bs.findIndex(function (b) { return b.classList.contains('on'); });
    var dir = (e.key === 'ArrowRight') !== (document.documentElement.dir === 'rtl') ? 1 : -1;
    var n = bs[(i + dir + bs.length) % bs.length];
    if (n) { e.preventDefault(); n.focus(); if (!example) setTask(n.getAttribute('data-task')); }
});

/* ═══ question, practice bank, charts ═══════════════════════════════════ */
function bankTaskOf(id) { return /^t2-/.test(id) ? 'task2' : /^gt-/.test(id) ? 'task1_gt' : /^ac-/.test(id) ? 'task1_academic' : ''; }
function loadBank() {
    if (bank) return Promise.resolve(bank);
    if (!bankP) {
        bankP = fetch(CFG.bankUrl, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('bank ' + r.status); return r.json(); })
            .then(function (j) { bank = j; return j; })
            .catch(function (e) { bankP = null; throw e; });
    }
    return bankP;
}
function findBankItem(id) {
    if (!bank || !id) return null;
    var task = bankTaskOf(id), list = bank[task] || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
}
function renderChart() {
    var acad = S.task === 'task1_academic';
    var showBank = !!(acad && S.chart && CH);
    if (showBank) {
        el.chartThumb.innerHTML = CH.svg(S.chart);
        el.chartTitle.textContent = S.chart.title || '';
    }
    el.chartBox.hidden = !showBank;
    if (el.upl) el.upl.hidden = !(acad && !S.chart);
    if (el.chartNote) el.chartNote.hidden = !(acad && !S.chart);
    el.qTag.hidden = !S.qid;
}
function useQuestion(item, task, how) {
    if (!item) return;
    if (task !== S.task) setTask(task, true);
    el.q.value = item.q;
    S.qid = item.id;
    S.chart = item.chart || null;
    if (S.chart) S.upload = null;
    renderChart();
    track(how || 'bank_pick', { id: item.id, task: task });
    touch();
    scheduleAnalysis(0);
}
function randomQuestion(mock) {
    loadBank().then(function () {
        var list = bank[S.task] || [];
        if (!list.length) return;
        var pick, guard = 0;
        do { pick = list[Math.floor(Math.random() * list.length)]; } while (pick.id === S.qid && list.length > 1 && ++guard < 8);
        useQuestion(pick, S.task, mock ? 'mock' : 'random');
        if (mock) { resetTimer(true); startTimer(); setView('write'); try { el.ta.focus({ preventScroll: true }); } catch (e) {} }
    }, function () { toast(t('bank_failed')); });
}
function filterKeyOf(item, task) { return task === 'task2' ? item.type : task === 'task1_gt' ? item.tone : (item.chart && item.chart.kind === 'hbar' ? 'bar' : (item.chart || {}).kind); }
function renderBank() {
    var list = (bank && bank[S.task]) || [], types = T.bank_types || {}, topics = T.bank_topics || {};
    var keys = [];
    list.forEach(function (it) { var k = filterKeyOf(it, S.task); if (k && keys.indexOf(k) < 0) keys.push(k); });
    if (bankFilter !== 'all' && keys.indexOf(bankFilter) < 0) bankFilter = 'all';
    var f = '<button type="button" class="tc-chip' + (bankFilter === 'all' ? ' on' : '') + '" data-f="all">' + esc(t('bank_all')) + '</button>';
    keys.forEach(function (k) { f += '<button type="button" class="tc-chip' + (bankFilter === k ? ' on' : '') + '" data-f="' + esc(k) + '">' + esc(types[k] || k) + '</button>'; });
    el.bankFilters.innerHTML = f;
    var h = '';
    list.forEach(function (it) {
        if (bankFilter !== 'all' && filterKeyOf(it, S.task) !== bankFilter) return;
        var meta = [types[filterKeyOf(it, S.task)] || ''];
        if (it.topic) meta.push(topics[it.topic] || it.topic);
        var body = '<span class="iw-bank-q">' + esc(String(it.q).split('\n\n')[0]) + '</span><span class="iw-bank-m">'
            + meta.filter(Boolean).map(function (m) { return '<span>' + esc(m) + '</span>'; }).join('') + '</span>';
        if (it.chart && CH) body = '<span class="iw-bank-row">' + CH.svg(it.chart) + '<span>' + body + '</span></span>';
        h += '<button type="button" class="iw-bank-i' + (it.id === S.qid ? ' on' : '') + '" data-id="' + esc(it.id) + '" title="' + esc(t('bank_use')) + '">' + body + '</button>';
    });
    el.bankList.innerHTML = h || '<p class="iw-dlg-note">—</p>';
}
function openBank() {
    if (example) return;
    if (!el.bank.open) { try { el.bank.showModal(); } catch (e) { el.bank.setAttribute('open', ''); } }
    track('bank_open', { task: S.task });
    el.bankList.innerHTML = '<p class="iw-dlg-note">' + esc(t('bank_loading')) + '</p>';
    loadBank().then(renderBank, function () { el.bankList.innerHTML = '<p class="iw-dlg-note">' + esc(t('bank_failed')) + '</p>'; });
}
el.bankBtn.addEventListener('click', openBank);
el.randomBtn.addEventListener('click', function () { if (!example) randomQuestion(false); });
el.bankFilters.addEventListener('click', function (e) {
    var b = e.target.closest('[data-f]'); if (!b) return;
    bankFilter = b.getAttribute('data-f'); renderBank();
});
el.bankList.addEventListener('click', function (e) {
    var b = e.target.closest('[data-id]'); if (!b) return;
    var it = findBankItem(b.getAttribute('data-id'));
    closeDialog(el.bank);
    useQuestion(it, S.task, 'bank_pick');
});
function closeDialog(d) { try { d.close(); } catch (e) { d.removeAttribute('open'); } }
[el.bank, el.chartDlg].forEach(function (d) {
    d.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]') || e.target === d) closeDialog(d);
    });
});
el.chartThumb.addEventListener('click', function () {
    if (!S.chart || !CH) return;
    el.chartBig.innerHTML = CH.svg(S.chart);
    try { el.chartDlg.showModal(); } catch (e) { el.chartDlg.setAttribute('open', ''); }
    track('chart_zoom');
});
el.q.addEventListener('input', function () {
    if (S.qid) {
        var it = findBankItem(S.qid);
        if (it && el.q.value.trim() !== String(it.q).trim()) { S.qid = ''; renderChart(); }
    }
    if (!el.q.value.trim() && S.chart) { S.chart = null; renderChart(); }
    touch();
    scheduleAnalysis();
});

/* The chart image a candidate attaches for their own question (intl only — the
   RU grader is text-only and would drop it). */
if (el.uplZone) {
    el.uplZone.addEventListener('tool-uploader:file', function (e) {
        var f = e.detail && e.detail.file;
        if (!f) return;
        var r = new FileReader();
        r.onload = function () {
            var d = String(r.result || ''), i = d.indexOf(',');
            S.upload = { blob: f, name: f.name || 'chart', media: f.type || 'image/png', data: i >= 0 ? d.slice(i + 1) : '' };
            track('chart_upload', { kb: Math.round((f.size || 0) / 1024) });
            touch();
        };
        r.readAsDataURL(f);
    });
    el.uplZone.addEventListener('tool-uploader:clear', function () { S.upload = null; touch(); });
}

/* ═══ the sheet: mirror + highlights ═════════════════════════════════════ */
var HL_API = !!(window.CSS && CSS.highlights && typeof window.Highlight === 'function');
var FIELD_SIZING = !!(window.CSS && CSS.supports && CSS.supports('field-sizing', 'content'));
var HL_NAMES = ['iw-mech', 'iw-rep', 'iw-link', 'iw-style', 'iw-typo', 'iw-ai', 'iw-quote', 'iw-focus'];
var mirrorText = null;
var CAT = {
    typos: 'typo', contractions: 'style', informal: 'style', cliche: 'style', vague: 'style', you_reader: 'style',
    repetition: 'rep', linker_overuse: 'link', linker_mechanical: 'link',
    // the frame of the task: worth the same attention as a word choice
    signoff_mismatch: 'style', greeting_mismatch: 'style', no_purpose: 'style', no_conclusion: 'style', opinion_in_t1: 'style'
};

function autosize() {
    if (FIELD_SIZING) return;
    el.ta.style.height = 'auto';
    el.ta.style.height = el.ta.scrollHeight + 'px';
}
function plainMirror() {
    var txt = el.ta.value + '\u200b';
    if (HL_API) {
        if (!mirrorText || mirrorText.parentNode !== el.hl) { el.hl.textContent = ''; mirrorText = document.createTextNode(''); el.hl.appendChild(mirrorText); }
        mirrorText.nodeValue = txt;
    } else {
        el.hl.textContent = txt;
        mirrorText = null;
    }
}
function clearHighlights() {
    if (!HL_API) return;
    HL_NAMES.forEach(function (n) { try { CSS.highlights.delete(n); } catch (e) {} });
}
/* Where the examiner's quotes stand in the text NOW: the person edits after the
   grade, so an offset from the report is a hint, the words themselves are the
   truth. A quote no longer in the text is a fix that was made. */
function locate(text, quote, hint) {
    if (!quote) return -1;
    var at = -1, from = 0, best = -1, bestD = Infinity;
    while ((at = text.indexOf(quote, from)) >= 0) {
        var d = Math.abs(at - (hint || 0));
        if (d < bestD) { bestD = d; best = at; }
        from = at + 1;
    }
    return best;
}
function aiIssues() {
    var rep = example ? example.data.report : S.report;
    if (!rep || !rep.inline_issues) return [];
    var text = el.ta.value;
    return rep.inline_issues.map(function (it, i) {
        var at = locate(text, it.quote, it.offset);
        return { i: i, item: it, s: at, e: at >= 0 ? at + String(it.quote).length : -1, done: at < 0 };
    });
}
function paintHighlights() {
    var text = el.ta.value, n = text.length;
    var groups = { mech: [], rep: [], link: [], style: [], typo: [], ai: [], quote: [], focus: [] };
    function push(g, s, e) { s = Math.max(0, Math.min(n, s)); e = Math.max(s, Math.min(n, e)); if (e > s) groups[g].push([s, e]); }
    if (view.hl && analysis && analysis.text === text) {
        analysis.findings.forEach(function (f) {
            var g = CAT[f.id] || 'mech';
            (f.ranges || []).forEach(function (r) { push(g, r[0], r[1]); });
        });
    }
    if (view.hl) aiIssues().forEach(function (x) { if (!x.done) push('ai', x.s, x.e); });
    if (focus) focus.ranges.forEach(function (r) { push(focus.kind === 'quote' ? 'quote' : 'focus', r[0], r[1]); });
    if (HL_API) {
        plainMirror();
        clearHighlights();
        var prio = { mech: 1, rep: 2, link: 3, style: 4, typo: 5, ai: 6, quote: 7, focus: 8 };
        Object.keys(groups).forEach(function (g) {
            if (!groups[g].length) return;
            var ranges = groups[g].map(function (r) {
                var rg = document.createRange();
                rg.setStart(mirrorText, r[0]); rg.setEnd(mirrorText, r[1]);
                return rg;
            });
            try {
                var h = new Highlight();
                ranges.forEach(function (rg) { h.add(rg); });
                h.priority = prio[g];
                CSS.highlights.set('iw-' + g, h);
            } catch (e) {}
        });
        return;
    }
    // <mark> fallback: cut the text at every range edge, give each piece the
    // strongest class that covers it.
    var order = ['focus', 'quote', 'ai', 'typo', 'style', 'link', 'rep', 'mech'], cuts = [0, n], k;
    for (k in groups) groups[k].forEach(function (r) { cuts.push(r[0], r[1]); });
    cuts = cuts.filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    var html = '';
    for (var i = 0; i < cuts.length - 1; i++) {
        var a = cuts[i], b = cuts[i + 1], cls = '';
        for (var o = 0; o < order.length && !cls; o++) {
            var gs = groups[order[o]];
            for (var j = 0; j < gs.length; j++) if (gs[j][0] <= a && gs[j][1] >= b) { cls = order[o]; break; }
        }
        var piece = esc(text.slice(a, b));
        html += cls ? '<mark class="m-' + cls + '">' + piece + '</mark>' : piece;
    }
    el.hl.innerHTML = html + '\u200b';
}
/* A text range of the mirror, whatever it is made of (one text node with the
   Highlight API, text split by <mark>s without it). */
function mirrorRange(s, e) {
    var walker = document.createTreeWalker(el.hl, NodeFilter.SHOW_TEXT), node, pos = 0, rg = document.createRange(), started = false;
    while ((node = walker.nextNode())) {
        var len = node.nodeValue.length;
        if (!started && s <= pos + len) { rg.setStart(node, Math.max(0, s - pos)); started = true; }
        if (started && e <= pos + len) { rg.setEnd(node, Math.max(0, e - pos)); return rg; }
        pos += len;
    }
    return started ? rg : null;
}
/* Bring a range of the sheet into view — inside the sheet's own scroll box,
   never the page (⛔ auto-scroll). */
function revealRange(s, e) {
    var rg = mirrorRange(s, e);
    if (!rg) return;
    var rr = rg.getBoundingClientRect(), pr = el.paper.getBoundingClientRect();
    if (!rr || !rr.height) return;
    var top = rr.top - pr.top + el.paper.scrollTop, h = el.paper.clientHeight;
    if (rr.top < pr.top + 8 || rr.bottom > pr.bottom - 8) el.paper.scrollTop = Math.max(0, top - h / 3);
}
function setFocus(ranges, kind, key) {
    focus = ranges && ranges.length ? { ranges: ranges, kind: kind || 'focus', key: key || '' } : null;
    paintHighlights();
    if (focus) revealRange(focus.ranges[0][0], focus.ranges[0][1]);
}

/* ═══ editing ════════════════════════════════════════════════════════════ */
var typedOnce = false;
el.ta.addEventListener('input', function () {
    if (example) return;
    hidePop();
    autosize();
    // Old highlights stand on old offsets — drop them at once, repaint after the check.
    focus = null;
    clearHighlights();
    plainMirror();
    updateMeter();
    if (!typedOnce) { typedOnce = true; try { if (window.__stage) window.__stage('write'); } catch (e) {} }
    touch();
    scheduleAnalysis();
});
el.ta.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') { e.preventDefault(); grade(false); }
    if (e.key === 'Escape') hidePop();
});
el.q.addEventListener('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') { e.preventDefault(); grade(false); }
});
/* Replace a span so that Ctrl+Z still undoes it: insertText goes through the
   editing pipeline, setRangeText does not. */
function replaceSpan(s, e, to) {
    var ta = el.ta;
    try { ta.focus({ preventScroll: true }); } catch (x) { ta.focus(); }
    ta.setSelectionRange(s, e);
    var ok = false;
    // insertText edits whatever has focus: when the sheet is hidden (the «Разбор»
    // view on a phone) the textarea cannot take it, and the text goes in directly
    if (document.activeElement === ta) {
        try { ok = document.execCommand && document.execCommand('insertText', false, to); } catch (x) { ok = false; }
    }
    if (!ok) {
        ta.setRangeText(to, s, e, 'end');
        ta.dispatchEvent(new Event('input', { bubbles: true }));
    }
}
function applyFixes(fixes) {
    if (!analysis || analysis.text !== el.ta.value) return;   // offsets are of another text
    fixes.slice().sort(function (a, b) { return b.s - a.s; }).forEach(function (f) {
        if (el.ta.value.slice(f.s, f.e).length === f.e - f.s) replaceSpan(f.s, f.e, f.to);
    });
    scheduleAnalysis(0);
}

/* An examiner's fix as a change to the candidate's own words: the quote with
   the removed words struck and the new ones marked, and the reason in the
   chosen language. Null when the fix is advice («vary your linkers») — that
   stays «quote → advice». */
function fixView(it) {
    var c = A.correction(it.quote, it.fix_en);
    if (!c) return null;
    var local = LOCALE !== 'en' && it.fix_local && !view.explEn;
    return { diff: markChange(it.quote, c.text), why: local ? A.correctionReason(it.fix_local) : c.why };
}
/* Removed words struck, new ones marked — the fix cards, the Band 9 version
   and the PDF all draw a change this way (IeltsAnalyze.wordDiff); a text too
   long to compare shows as the new text alone. */
function markChange(from, to) {
    var ops = A.wordDiff(from, to);
    if (!ops) return esc(to);
    return ops.map(function (o) { return o.op === '=' ? esc(o.s) : o.op === '-' ? '<del>' + esc(o.s) + '</del>' : '<ins>' + esc(o.s) + '</ins>'; }).join('');
}
function fixBody(it, fv) {
    if (fv) return '<div class="iw-fix-d">' + fv.diff + '</div>' + (fv.why ? '<div class="iw-fix-why" dir="auto">' + esc(fv.why) + '</div>' : '');
    return '<div><span class="iw-fix-q">' + esc(it.quote) + '</span> → <span class="iw-fix-to">' + expl(it.fix_en, it.fix_local) + '</span></div>'
        + (it.fix_local && LOCALE !== 'en' && !view.explEn ? '<span class="iw-alt" dir="auto">' + esc(it.fix_en) + '</span>' : '');
}
/* «Заменить» on an examiner's fix: the quote becomes the corrected words, as one
   undoable edit; the fix then shows ✓, because its quote is gone from the text. */
function applyAiFix(i, from) {
    if (example) return;
    var x = aiIssues()[i], c = x && !x.done && A.correction(x.item.quote, x.item.fix_en);
    if (!c) return;
    replaceSpan(x.s, x.e, c.text);
    hidePop();
    track('fix_apply', { from: from, kind: 'ai' });
}

/* ═══ the word meter ═════════════════════════════════════════════════════ */
function updateMeter() {
    var n = A.wordCount(el.ta.value), min = minWords();
    el.words.textContent = n;
    var frac = Math.min(1, n / min), len = 100.53;
    el.ring.setAttribute('stroke-dashoffset', String(len * (1 - frac)));
    var ok = n >= min;
    el.meter.setAttribute('data-ok', ok ? 'on' : 'off');
    el.meterSub.textContent = ok ? t('words_done') : t('words_left', { n: min - n });
    // The same count as the check panel: a letter's greeting and sign-off are
    // not paragraphs (the analyzer knows that; between keystrokes we fall back).
    var p = (analysis && analysis.text === el.ta.value) ? analysis.paragraphs : A.paragraphs(el.ta.value).length;
    el.paras.textContent = t('paras_n', { n: p }) || (p + ' ¶');
}

/* ═══ the instant check ══════════════════════════════════════════════════ */
var anaT = 0;
function scheduleAnalysis(ms) { clearTimeout(anaT); anaT = setTimeout(runAnalysis, ms == null ? 240 : ms); }
function dict() { return (window.LangFreq && window.LangFreq.ready && typeof window.LangFreq.known === 'function') ? window.LangFreq : null; }
function loadDict() {
    if (dictP || !window.LangFreq || dict()) return;
    dictP = window.LangFreq.load({ base: CFG.freqBase }).then(function () { scheduleAnalysis(0); }, function () { dictP = null; });
}
function runAnalysis() {
    var text = el.ta.value;
    if (A.wordCount(text) >= 12) loadDict();
    analysis = A.analyze(text, { task: S.task, question: el.q.value, dict: dict(), ignore: S.ignore });
    analysis.text = text;
    updateMeter();
    paintHighlights();
    renderSide();
    updateGoButton();
}
function findingText(f) {
    var m = (T.f || {})[f.id];
    if (!m) return f.id;
    var p = {};
    for (var k in f.params) {
        var v = f.params[k];
        if (typeof v === 'number' && v % 1) v = fmtNum(v);
        // English words inside a sentence in the page's language: isolate them
        // (FSI … PDI), or an Arabic sentence reorders «a lot of → many» around
        // its own punctuation. Invisible in left-to-right languages.
        if (typeof v === 'string' && /[A-Za-z]/.test(v)) v = '\u2068' + v + '\u2069';
        p[k] = v;
    }
    if (f.id === 'under_length' || f.id === 'too_short') p.n = f.params.n;
    if (p.want == null && f.params.want) p.want = f.params.want;
    return tpl(m, p);
}

/* ═══ popover at a marked word ═══════════════════════════════════════════ */
function hidePop() { if (!el.pop.hidden) { el.pop.hidden = true; el.pop.innerHTML = ''; } }
function hitAt(pos) {
    var ai = aiIssues();
    for (var i = 0; i < ai.length; i++) if (!ai[i].done && pos >= ai[i].s && pos <= ai[i].e) return { kind: 'ai', x: ai[i] };
    if (!analysis || analysis.text !== el.ta.value) return null;
    var order = ['typos', 'contractions', 'informal', 'cliche', 'vague', 'linker_overuse', 'repetition', 'lowercase_i', 'lowercase_start', 'you_reader', 'spacing', 'long_sentence'];
    for (var o = 0; o < order.length; o++) {
        var f = analysis.findings.filter(function (x) { return x.id === order[o]; })[0];
        if (!f) continue;
        for (var r = 0; r < f.ranges.length; r++) {
            if (pos >= f.ranges[r][0] && pos <= f.ranges[r][1]) return { kind: 'find', f: f, r: r };
        }
    }
    return null;
}
function showPopAt(s, e, html) {
    el.pop.innerHTML = html;
    el.pop.hidden = false;
    var rg = mirrorRange(s, e);
    if (!rg) return;
    var rr = rg.getBoundingClientRect(), pr = el.paper.getBoundingClientRect();
    var w = el.pop.offsetWidth, maxL = el.paper.clientWidth - w - 8;
    var left = Math.max(8, Math.min(maxL, rr.left - pr.left));
    var top = rr.bottom - pr.top + el.paper.scrollTop + 6;
    el.pop.style.left = left + 'px';
    el.pop.style.top = top + 'px';
    if (document.documentElement.dir === 'rtl') { el.pop.style.left = left + 'px'; }
}
function onCaret() {
    if (example) return;
    var ta = el.ta;
    if (ta.selectionStart !== ta.selectionEnd) return hidePop();
    var hit = hitAt(ta.selectionStart);
    if (!hit) return hidePop();
    var h = '';
    if (hit.kind === 'ai') {
        var it = hit.x.item, fv = fixView(it);
        h = '<div class="iw-pop-h"><span class="iw-pill">' + esc(critShort(it.category)) + '</span><button type="button" class="iw-pop-x" data-pop="x" aria-label="×">×</button></div>'
            + (fv ? fixBody(it, fv)
                : '<div>' + esc(view.explEn || !it.fix_local ? it.fix_en : it.fix_local) + '</div>'
                    + (it.fix_local && !view.explEn && LOCALE !== 'en' ? '<div class="iw-alt" dir="auto">' + esc(it.fix_en) + '</div>' : ''))
            + '<div class="iw-pop-acts">'
            + (fv ? '<button type="button" class="iw-mini pri" data-pop="aifix" data-i="' + hit.x.i + '">' + esc(t('fix_apply')) + '</button>' : '')
            + '<button type="button" class="iw-mini" data-pop="fixes" data-i="' + hit.x.i + '">' + esc(t('tab_fixes')) + '</button></div>';
        showPopAt(hit.x.s, hit.x.e, h);
        track('pop', { kind: 'ai' });
        return;
    }
    var f = hit.f, fx = (f.fixes || [])[hit.r] || null;
    h = '<div class="iw-pop-h"><span class="iw-pill">' + esc(critShort(f.crit)) + '</span><button type="button" class="iw-pop-x" data-pop="x" aria-label="×">×</button></div>';
    if (f.id === 'typos' && fx) {
        h += '<div>' + esc(t('fix_maybe')) + '</div><div class="iw-pop-acts">'
            + (fx.alts || [fx.to]).map(function (a, i) { return '<button type="button" class="iw-mini' + (i ? '' : ' pri') + '" data-pop="apply" data-s="' + fx.s + '" data-e="' + fx.e + '" data-to="' + esc(a) + '">' + esc(a) + '</button>'; }).join('')
            + '<button type="button" class="iw-mini" data-pop="ignore" data-w="' + esc(String(fx.w || '').toLowerCase()) + '">' + esc(t('fix_ignore')) + '</button></div>';
    } else {
        h += '<div>' + esc(findingText(f)) + '</div>';
        if (fx) h += '<div class="iw-pop-acts"><button type="button" class="iw-mini pri" data-pop="apply" data-s="' + fx.s + '" data-e="' + fx.e + '" data-to="' + esc(fx.to) + '">' + esc(t('fix_apply')) + ': ' + esc(fx.to) + '</button></div>';
    }
    showPopAt(f.ranges[hit.r][0], f.ranges[hit.r][1], h);
    track('pop', { kind: f.id });
}
el.ta.addEventListener('click', onCaret);
el.ta.addEventListener('keyup', function (e) { if (e.key && e.key.indexOf('Arrow') === 0 && !el.pop.hidden) onCaret(); });
el.pop.addEventListener('mousedown', function (e) { e.preventDefault(); });   // keep the caret where it is
el.pop.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pop]'); if (!b) return;
    var a = b.getAttribute('data-pop');
    if (a === 'x') return hidePop();
    if (a === 'aifix') return applyAiFix(+b.getAttribute('data-i'), 'pop');
    if (a === 'apply') {
        replaceSpan(+b.getAttribute('data-s'), +b.getAttribute('data-e'), b.getAttribute('data-to'));
        track('fix_apply', { from: 'pop' });
        hidePop();
        return;
    }
    if (a === 'ignore') {
        var w = b.getAttribute('data-w');
        if (w) { S.ignore[w] = 1; saveSetting('ignore', Object.keys(S.ignore).slice(-300)); }
        track('typo_ignore');
        hidePop();
        scheduleAnalysis(0);
        return;
    }
    if (a === 'fixes') {
        hidePop();
        view.tab = 'fixes'; view.side = 'report';
        setView('report');
        renderSide();
        var card = el.sideBody.querySelector('[data-fix="' + b.getAttribute('data-i') + '"]');
        if (card) { card.classList.add('on'); try { card.scrollIntoView({ block: 'nearest' }); } catch (x) {} }
    }
});
el.paper.addEventListener('scroll', function () { /* the popover scrolls with the text — nothing to do */ }, { passive: true });
document.addEventListener('pointerdown', function (e) {
    if (!el.pop.hidden && !el.pop.contains(e.target) && e.target !== el.ta) hidePop();
});

/* ═══ view switch (narrow container) ═════════════════════════════════════ */
function setView(v, reveal) {
    var was = view.view;
    view.view = v === 'report' ? 'report' : 'write';
    root.setAttribute('data-view', view.view);
    el.viewSeg.querySelectorAll('[data-view]').forEach(function (b) {
        var on = b.getAttribute('data-view') === view.view;
        b.classList.toggle('on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    /* On a narrow screen the two views share one place: the switch replaces
       what was under the finger, and the page stayed scrolled to where the
       button had been — the middle of the report. Bring the top of the new
       view back only if it is off-screen ('nearest' — no jump otherwise). */
    if (reveal && was !== view.view && el.viewSeg.offsetParent !== null) {
        try { (view.view === 'report' ? el.viewSeg : el.paper).scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }
}
el.viewSeg.addEventListener('click', function (e) {
    var b = e.target.closest('[data-view]'); if (!b) return;
    setView(b.getAttribute('data-view'));
    track('view', { v: view.view });
});

/* ═══ exam timer ═════════════════════════════════════════════════════════ */
var timerIv = 0, timerWarned = false;
function timerElapsed() { return S.timer.acc + (S.timer.run ? Date.now() - S.timer.start : 0); }
function spell(on) { el.ta.spellcheck = !!on; el.ta.setAttribute('spellcheck', on ? 'true' : 'false'); }
function startTimer() {
    if (!S.timer.limit) S.timer.limit = examMinutes() * 60000;
    S.timer.start = Date.now(); S.timer.run = true;
    spell(false);
    clearInterval(timerIv); timerIv = setInterval(renderTimer, 500);
    renderTimer();
    track('timer_start', { min: Math.round(S.timer.limit / 60000) });
    touch();
}
function pauseTimer() {
    S.timer.acc = timerElapsed(); S.timer.run = false;
    clearInterval(timerIv);
    renderTimer(); touch();
}
function resetTimer(silent) {
    S.timer = { limit: 0, start: 0, acc: 0, run: false };
    clearInterval(timerIv); timerWarned = false;
    spell(true);
    renderTimer();
    if (!silent) touch();
}
function renderTimer() {
    var running = S.timer.run, used = timerElapsed(), started = running || used > 0;
    var limit = S.timer.limit || examMinutes() * 60000, left = limit - used;
    el.timerBox.setAttribute('data-run', running ? 'on' : 'off');
    el.timerBox.setAttribute('data-over', started && left < 0 ? 'on' : 'off');
    el.timerBox.querySelector('.iw-dot').hidden = !running;
    el.timerReset.hidden = !started;
    el.timerTxt.textContent = !started ? t('timer_idle', { min: examMinutes() }) : (left >= 0 ? fmtClock(left) : '+' + fmtClock(left));
    el.timerBtn.title = !started ? t('timer_title', { min: examMinutes() }) : (running ? t('timer_pause') : t('timer_resume'));
    el.timerBtn.setAttribute('aria-label', el.timerBtn.title);
    if (running && left < 0 && !timerWarned) { timerWarned = true; toast(t('timer_up'), 'info'); track('timer_up'); }
}
el.timerBtn.addEventListener('click', function () {
    if (example) return;
    if (S.timer.run) pauseTimer(); else startTimer();
});
el.timerReset.addEventListener('click', function () { resetTimer(false); track('timer_reset'); });

/* ═══ grading ════════════════════════════════════════════════════════════ */
function questionForGrader() {
    var q = el.q.value.trim();
    // The numbers in words, for the grader that cannot see the picture — and for
    // the one that can, so a misquoted figure is checkable against the source.
    if (S.task === 'task1_academic' && S.chart && CH) q += '\n\nChart data: ' + CH.dataText(S.chart);
    return q;
}
/* The chart the grader sees as a picture (intl reads images; RU gets the
   numbers in the question text). Shared by the grade and the order. */
function chartFor() {
    if (S.task === 'task1_academic' && CFG.seesCharts) {
        if (S.chart && CH) return CH.png(S.chart, 960).catch(function () { return null; });
        if (S.upload && S.upload.data) return Promise.resolve({ data: S.upload.data, media: S.upload.media });
    }
    return Promise.resolve(null);
}
function grade(payTokens) {
    if (busy || example) return;
    var text = el.ta.value.trim();
    if (text.length < (CFG.minChars || 120) || text.length > (CFG.maxChars || 12000)) { toast(t('err_length')); return; }
    hidePop();
    var payload = { task_type: S.task, question: questionForGrader(), essay: text, locale: LOCALE };
    if (payTokens) payload.pay_with_tokens = true;
    try { if (window.__stage) window.__stage('grade'); if (window.__aeFunnel) window.__aeFunnel('grade_click', { task: S.task, words: A.wordCount(text), pro: isPro() ? 1 : 0 }); } catch (e) {}
    var chartP = chartFor();
    var snapshot = { essay: el.ta.value, q: el.q.value, task: S.task };
    // Only a grade that will happen gets the «examiner is reading» screen; for
    // everyone else the answer is the offer, and a spinner before it would lie.
    var willGrade = isPro() || !!payTokens;
    if (willGrade) setBusy({ t0: Date.now(), snap: snapshot }); else el.go.disabled = true;
    chartP.then(function (c) {
        if (c) { payload.chart_data = c.data; payload.chart_media = c.media; }
        return fetch(CFG.scoreUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload)
        });
    }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { s: r.status, j: j }; });
    }).then(function (res) {
        el.go.disabled = false;
        if (res.s === 429) return fail(t('err_daily_cap'));
        if (res.s === 402) { setBusy(null); return showOffer({}); }
        if (res.s === 503) return fail(t('err_disabled'));
        if (!res.j || !res.j.ok) return fail((res.j && res.j.msg) ? res.j.msg : t('err_generic'));
        if (res.j.needs_premium) {
            setBusy(null);
            if (res.j.insufficient_tokens) toast(t('insufficient_tokens'));
            return showOffer(res.j);
        }
        if (!busy) setBusy({ t0: Date.now(), snap: snapshot });
        busy.job = res.j.job;
        try { sessionStorage.setItem(JOB_KEY, JSON.stringify({ job: res.j.job, at: busy.t0, snap: snapshot })); } catch (e) {}
        poll();
    }).catch(function () { el.go.disabled = false; fail(t('err_generic')); });
}
function setBusy(b) {
    if (busy && busy.iv) clearInterval(busy.iv);
    busy = b;
    el.go.disabled = !!b;
    if (b) {
        offerData = null;
        b.iv = setInterval(function () { var n = el.sideBody.querySelector('.iw-busy-t'); if (n) n.textContent = fmtClock(Date.now() - b.t0); }, 500);
    }
    renderSide();
    updateGoButton();
}
function fail(msg) {
    setBusy(null);
    try { sessionStorage.removeItem(JOB_KEY); } catch (e) {}
    toast(msg);
}
function poll() {
    if (!busy || !busy.job) return;
    if (Date.now() - busy.t0 > POLL_MAX_MS) return fail(t('err_failed'));
    fetch(CFG.statusUrl + '/' + encodeURIComponent(busy.job), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json().then(function (j) { return { s: r.status, j: j }; }); })
        .then(function (res) {
            if (!busy) return;
            if (res.s === 404) return fail(t('err_failed'));
            var r = res.j && res.j.result;
            if (!r || r.status === 'pending') { setTimeout(poll, POLL_MS); return; }
            if (r.status === 'error') {
                // A bought grade: the order knows it is paid — ask it, it offers the retry.
                if (busy.order) { var o = busy.order; setBusy(null); return claimOrder(o.ref, o.token, true); }
                return fail(t('err_failed'));
            }
            delivered(r, busy.snap);
        })
        .catch(function () { if (busy) setTimeout(poll, POLL_MS * 2); });
}
function delivered(r, snap) {
    var prev = S.report && typeof S.report.overall === 'number' ? S.report.overall : null;
    if (busy && busy.order) { track('paid_delivered'); clearOrder(); }
    paid = null;
    setBusy(null);
    try { sessionStorage.removeItem(JOB_KEY); } catch (e) {}
    S.report = r;
    S.reportFor = snap ? snap.essay : el.ta.value;
    S.reportQ = snap ? snap.q : el.q.value;
    S.reportTask = snap ? snap.task : S.task;
    S.reportAt = Date.now();
    S.history = (S.history || []).concat([{ band: r.overall, at: S.reportAt }]).slice(-20);
    S.prevBand = prev;
    view.side = 'report'; view.tab = 'criteria';
    // On a narrow screen the report is another tab: switch to it — unless the
    // person is typing (writing on while the grade runs is allowed), then the
    // band on the tab says it is ready.
    if (document.activeElement !== el.ta && document.activeElement !== el.q) setView('report', true);
    renderSide();
    paintHighlights();
    updateGoButton();
    if (ed) { try { ed.touch(true); ed.exported(); } catch (e) {} }
    try {
        if (window.__aeToolComplete) window.__aeToolComplete({ task: S.reportTask, band: r.overall, depth: r.depth, words: r.word_count, cached: r.cached ? 1 : 0 });
    } catch (e) {}
    try { if (window.__announce) window.__announce(t('overall_label') + ': ' + fmtBand(r.overall)); } catch (e) {}
}
function resumePendingJob() {
    var j = null;
    try { j = JSON.parse(sessionStorage.getItem(JOB_KEY) || 'null'); } catch (e) {}
    if (!j || !j.job || Date.now() - (j.at || 0) > 25 * 60000) { try { sessionStorage.removeItem(JOB_KEY); } catch (e) {} return; }
    setBusy({ t0: j.at, job: j.job, snap: j.snap });
    poll();
}
el.go.addEventListener('click', function () { grade(false); });
function updateGoButton() {
    var edited = S.report && !example && el.ta.value !== S.reportFor;
    el.goTxt.textContent = (S.report && edited) ? t('regrade_btn') : t('grade_btn');
    // The «Report» tab on a narrow screen says what is behind it: the band once
    // there is one, the number of instant-check notes before that.
    var nf = (analysis && analysis.text === el.ta.value && el.ta.value.trim()) ? analysis.findings.length : 0;
    el.vBand.textContent = (S.report && typeof S.report.overall === 'number') ? fmtBand(S.report.overall) : (nf ? '⚡' + nf : '');
}

/* ═══ the side panel ═════════════════════════════════════════════════════ */
/* The panel is redrawn on every pause in typing. Someone reading «Fixes» while
   correcting the text must not be thrown back to the top of it each time: the
   scroll position survives a redraw of the same view and tab. */
var sideKey = '', redraw = false;
function renderSide() {
    var key = (example ? 'ex' : busy ? 'busy' : paid ? 'paid' : offerData ? 'offer' : S.report ? 'rep' : el.ta.value.trim() ? 'check' : 'idle') + ':' + view.tab;
    redraw = key === sideKey;              // same view again: no entry animation, same scroll
    var keep = redraw ? el.sideBody.scrollTop : 0;
    sideKey = key;
    if (example) renderReport(example.data.report, { example: true });
    else if (busy) renderBusy();
    else if (paid) renderPaid();
    else if (offerData) renderOffer();
    else if (S.report) renderReport(S.report, {});
    else if (!el.ta.value.trim()) renderIdle();
    else renderCheckPanel();
    if (keep) el.sideBody.scrollTop = keep;
}
function setHead(h) { el.sideHead.innerHTML = h; el.sideHead.hidden = !h; }
function setFoot(h) { el.sideFoot.innerHTML = h; }
var idleHTML = el.sideBody.innerHTML;
function renderIdle() {
    setHead('');
    el.sideBody.innerHTML = idleHTML;
    setFoot('');
}
function renderBusy() {
    setHead('');
    el.sideBody.innerHTML = '<div class="iw-busy iw-in" role="status"><div class="iw-spin" aria-hidden="true"></div>'
        + '<h3 class="iw-h">' + esc(t('busy_title')) + '</h3><p class="iw-sub">' + esc(busy.order ? t('paid_grading') : t('busy_hint')) + '</p>'
        + '<div class="iw-busy-t">' + fmtClock(Date.now() - busy.t0) + '</div></div>';
    setFoot('');
}

/* The instant check, as a panel of its own or a tab of the report. */
function checkHTML() {
    var a = analysis;
    if (!a || !el.ta.value.trim()) return '<p class="iw-sub">' + esc(t('live_empty')) + '</p>';
    var min = a.minWords, h = '<div class="iw-stats">';
    h += '<div class="tc-stat' + (a.words >= min ? ' good' : '') + '"><div class="tc-stat-l">' + esc(t('stat_words')) + '</div><div class="tc-stat-v">' + a.words + '</div><div class="tc-stat-s">' + esc(a.words >= min ? t('words_done') : t('words_left', { n: min - a.words })) + '</div></div>';
    h += '<div class="tc-stat"><div class="tc-stat-l">' + esc(t('stat_paras')) + '</div><div class="tc-stat-v">' + a.paragraphs + '</div></div>';
    h += '<div class="tc-stat"><div class="tc-stat-l">' + esc(t('stat_sents')) + '</div><div class="tc-stat-v">' + a.sentences + '</div><div class="tc-stat-s">' + esc(t('stat_sents_sub', { n: Math.round(a.avgSentence) })) + '</div></div>';
    if (a.vocab) {
        var v = a.vocab.pct, hi = v.B2 + v.C;
        h += '<div class="tc-stat"><div class="tc-stat-l">' + esc(t('stat_vocab')) + '</div><div class="tc-stat-v">' + hi + '%</div>'
            + '<div class="iw-vbar" aria-hidden="true"><i style="width:' + v.A + '%;background:#22c55e"></i><i style="width:' + v.B1 + '%;background:#3b82f6"></i><i style="width:' + v.B2 + '%;background:#8b5cf6"></i><i style="width:' + v.C + '%;background:#f59e0b"></i></div>'
            + '<div class="tc-stat-s">' + esc(t('stat_vocab_sub')) + '</div></div>';
    } else {
        h += '<div class="tc-stat"><div class="tc-stat-l">' + esc(t('stat_vocab')) + '</div><div class="tc-stat-v">—</div><div class="tc-stat-s">' + esc(dictP ? t('stat_vocab_wait') : '') + '</div></div>';
    }
    h += '</div>';
    var groups = { task: [], coherence: [], lexical: [], grammar: [] };
    a.findings.forEach(function (f, i) { (groups[f.crit] || groups.grammar).push({ f: f, i: i }); });
    var any = a.findings.length > 0;
    if (!any) h += '<div class="iw-ok iw-in" style="margin-top:12px">' + ICON_OK.replace('<svg', '<svg style="width:18px;height:18px;flex:0 0 auto;color:var(--iw-green)"') + '<span>' + esc(t('live_clean')) + '</span></div>';
    ['task', 'coherence', 'lexical', 'grammar'].forEach(function (c) {
        if (!groups[c].length) return;
        h += '<div class="iw-grp"><h4 class="iw-grp-h"><span class="iw-pill">' + esc(critShort(c)) + '</span>' + esc((T.crit_groups || {})[c] || critName(c)) + '</h4>';
        groups[c].forEach(function (x) {
            var f = x.f, hasR = f.ranges && f.ranges.length;
            var on = focus && focus.key === 'f' + x.i;
            h += '<div class="iw-find-w"><button type="button" class="iw-find' + (on ? ' on' : '') + '"' + (hasR ? ' data-find="' + x.i + '"' : ' data-static') + '>'
                + '<span class="iw-sev s' + f.sev + '" aria-hidden="true"></span><span class="iw-find-t">' + esc(findingText(f)) + '</span></button>';
            if (f.fixes && f.fixes.length && f.id !== 'typos') {
                h += '<div class="iw-find-a" style="margin-inline-start:28px"><button type="button" class="iw-mini" data-fixall="' + x.i + '">' + esc(t('fix_all', { n: f.fixes.length })) + '</button></div>';
            }
            h += '</div>';
        });
        h += '</div>';
    });
    if (a.linkers && a.linkers.length) {
        h += '<div class="iw-grp"><h4 class="iw-grp-h">' + esc(t('linkers_used')) + '</h4><div class="iw-chips">'
            + a.linkers.slice(0, 14).map(function (l) { return '<span class="iw-wchip">' + esc(l.p) + (l.n > 1 ? '<b>×' + l.n + '</b>' : '') + '</span>'; }).join('') + '</div></div>';
    }
    if (a.vocab && a.vocab.strong && a.vocab.strong.length) {
        h += '<div class="iw-grp"><h4 class="iw-grp-h">' + esc(t('strong_words')) + '</h4><div class="iw-chips">'
            + a.vocab.strong.map(function (w) { return '<span class="iw-wchip">' + esc(w) + '</span>'; }).join('') + '</div></div>';
    }
    if (a.topWords && a.topWords.length) {
        h += '<div class="iw-grp"><h4 class="iw-grp-h">' + esc(t('top_words')) + '</h4><div class="iw-chips">'
            + a.topWords.map(function (w) { return '<span class="iw-wchip' + (w.topic ? ' topic' : '') + '"' + (w.topic ? ' title="' + esc(t('topic_word')) + '"' : '') + '>' + esc(w.w) + '<b>×' + w.n + '</b></span>'; }).join('') + '</div></div>';
    }
    h += '<label class="iw-hltog"><input type="checkbox" data-hltog' + (view.hl ? ' checked' : '') + '> ' + esc(t('highlights_toggle')) + '</label>';
    return h;
}
function renderCheckPanel() {
    setHead('<div><h2 class="iw-h">' + esc(t('live_title')) + '</h2><p class="iw-sub">' + esc(t('live_note')) + '</p></div>');
    el.sideBody.innerHTML = checkHTML();
    setFoot('');
}

/* Premium offer — what the examiner grade contains, the example, the price
   lane. The instant check stays under it: the person keeps what they had. */
function showOffer(j) {
    offerData = j || {};
    track('offer_shown', { logged: CFG.loggedIn ? 1 : 0 });
    setView('report', true);
    renderSide();
}
function renderOffer() {
    setHead('');
    var od = offerData || {}, pts = T.premium_points || [];
    var h = '<div class="iw-offer iw-in"><h3 class="iw-h">' + esc(t('offer_title')) + '</h3><ul class="iw-points">'
        + pts.map(function (p) { return '<li>' + ICON_OK + '<span>' + esc(p) + '</span></li>'; }).join('') + '</ul>';
    var buy = buyHTML(od);
    h += '<div class="iw-acts">' + buy.html + '<button type="button" class="tc-btn ghost" data-act="example">' + esc(t('example_btn')) + '</button></div>';
    if (buy.note) h += '<p class="iw-sub">' + esc(buy.note) + '</p>';
    // Премиум, чьи оценки месяца кончились, — не покупатель Премиума: ему
    // говорится, что дальше по одной за токены, а не «оформите план».
    if (od.premium_spent) {
        h += '<p class="iw-sub">' + esc(t('offer_premium_spent', { plan: CFG.plan || '', cap: od.premium_cap || 0 })) + '</p>';
    } else {
        h += '<p class="iw-sub">' + esc(t('offer_or_plan', { plan: CFG.plan || '', cap: od.premium_cap || 0 }))
            + ' <a href="' + esc(CFG.buyUrl) + '" data-offer-cta>' + esc(t('premium_cta')) + '</a></p>';
    }
    h += '<p class="iw-sub">' + esc(t('premium_accuracy')) + '</p></div>';
    h += '<div class="iw-grp"><h4 class="iw-grp-h">' + esc(t('live_title')) + '</h4></div>' + checkHTML();
    el.sideBody.innerHTML = h;
    setFoot('');
    if (buy.order) ensureOrder().catch(function () {});
}
/* How this person can buy this one grade — decided by what the server offered:
   tokens on the balance (one click), the rouble cashier (the document door:
   a guest pays with an e-mail, the account is made after the money), or a
   token pack through Polar on intl (signed-in only: Polar has no guest
   checkout). The essay is saved as an order BEFORE the cashier, and its number
   rides in the link — the webhook grades it even if the tab is closed. */
function buyHTML(od) {
    var cost = od.token_cost || CFG.tokenCost, purpose = ' data-tmb-purpose="ielts_grade" data-tmb-purpose-locale="' + esc(LOCALE) + '"';
    if (od.pay_per_token && typeof od.balance === 'number' && od.balance >= cost) {
        return { html: '<button type="button" class="tc-btn" data-act="tokens">' + esc(t('pay_with_tokens', { n: cost })) + '</button>',
                 note: t('offer_balance', { n: od.balance }) };
    }
    var doc = od.docs && od.docs.ielts_grade;
    if (doc && doc.rub > 0) {
        var price = doc.rub + ' ₽';
        return { order: true, note: t('offer_note'),
                 html: '<a class="tc-btn" href="/pricing#tokens" data-iw-buy="doc" data-tmb-doc="' + esc(doc.code) + '" data-tmb-doc-price="' + doc.rub + '"'
                     + ' data-tmb-title="' + esc(t('offer_buy', { price: price })) + '"' + purpose + '>' + esc(t('offer_buy', { price: price })) + '</a>' };
    }
    var pay = od.pay;
    if (pay && pay.rail === 'polar') {
        if (!CFG.loggedIn) {
            var back = location.pathname + location.search;
            return { note: t('offer_login_note'),
                     html: '<a class="tc-btn" data-iw-buy="login" href="/' + esc(LOCALE) + '/login?redirect=' + encodeURIComponent(back) + '">' + esc(t('offer_login')) + '</a>' };
        }
        var c = pay.consent ? '<label class="iw-consent"><input type="checkbox" id="iwPayConsent"> <span>' + esc(pay.consent) + '</span></label>' : '';
        return { order: true, note: t('offer_note'),
                 html: c + '<button type="button" class="tc-btn" data-act="polar-buy">' + esc(t('offer_buy', { price: pay.label || '' })) + '</button>' };
    }
    if (pay && pay.rail === 'yookassa') {
        var pr = pay.price_rub ? pay.price_rub + ' ₽' : '';
        return { order: true, note: t('offer_note'),
                 html: '<a class="tc-btn" href="/pricing#tokens" data-iw-buy="pack" data-tmb-topup="1" data-tmb-pack="' + esc(pay.pack) + '"' + purpose + '>'
                     + esc(pr ? t('offer_buy', { price: pr }) : t('offer_buy_plain')) + '</a>' };
    }
    return { html: '' };
}

/* ── the order: the essay saved for a purchase ─────────────────────────── */
function hashStr(x) { var h = 5381, i; for (i = 0; i < x.length; i++) h = ((h << 5) + h + x.charCodeAt(i)) | 0; return (h >>> 0).toString(36); }
function orderPayload() { return { task_type: S.task, question: questionForGrader(), essay: el.ta.value.trim(), locale: LOCALE }; }
function sigOf(p) { return hashStr(p.task_type + '\u0001' + p.question + '\u0001' + p.essay + '\u0001' + (S.upload && S.upload.data ? S.upload.data.length : 0)); }
function readOrder() { try { var o = JSON.parse(localStorage.getItem(ORDER_KEY) || 'null'); return o && o.ref && o.token && Date.now() - (o.at || 0) < 7 * 864e5 ? o : null; } catch (e) { return null; } }
function clearOrder() { order = null; try { localStorage.removeItem(ORDER_KEY); } catch (e) {} }
/* The essay as it is NOW goes into the order: the person may have edited it
   between seeing the offer and pressing «Pay», and pays for the current text. */
function ensureOrder() {
    var p = orderPayload(), sig = sigOf(p);
    if (order && order.sig === sig) { stampLinks(); return Promise.resolve(order); }
    if (order) { p.ref = order.ref; p.token = order.token; }
    return chartFor().then(function (c) {
        if (c) { p.chart_data = c.data; p.chart_media = c.media; }
        return fetch(CFG.orderUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(p)
        });
    }).then(function (r) { return r.json().then(function (j) { return { s: r.status, j: j }; }); })
      .then(function (res) {
          if (!res.j || !res.j.ok || !res.j.ref) throw new Error(res.j && res.j.error || 'order');
          order = { ref: res.j.ref, token: res.j.token, sig: sig };
          try { localStorage.setItem(ORDER_KEY, JSON.stringify({ ref: order.ref, token: order.token, at: Date.now() })); } catch (e) {}
          stampLinks();
          return order;
      });
}
// The cashier reads the purpose from the link at the moment of paying.
function stampLinks() {
    if (!order) return;
    el.sideBody.querySelectorAll('[data-tmb-purpose="ielts_grade"]').forEach(function (a) {
        a.setAttribute('data-tmb-purpose-ref', String(order.ref));
        a.setAttribute('data-tmb-purpose-token', order.token);
    });
}
function buyPolar(btn) {
    var pay = offerData && offerData.pay;
    if (!pay || pay.rail !== 'polar') return;
    var consent = $('iwPayConsent');
    if (consent && !consent.checked) { toast(pay.consent_req || ''); try { consent.focus(); } catch (e) {} return; }
    if (btn) btn.disabled = true;
    track('offer_buy', { path: 'polar' });
    ensureOrder().then(function (o) {
        return fetch(pay.start_url, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ package: pay.pack, locale: LOCALE, consent: true, purpose: 'ielts_grade', purpose_ref: o.ref, purpose_token: o.token, purpose_locale: LOCALE })
        });
    }).then(function (r) { return r.json(); }).then(function (j) {
        if (btn) btn.disabled = false;
        if (!j || !j.url) { toast(t('err_generic')); return; }
        if (window.__polarCheckout && typeof window.__polarCheckout.open === 'function') window.__polarCheckout.open(j.url, {});
        else window.location.href = j.url;
    }).catch(function () { if (btn) btn.disabled = false; toast(t('err_generic')); });
}

/* ── a bought grade: back from the cashier, the e-mail link, the same tab ─ */
function renderPaid() {
    setHead('');
    var h = '<div class="iw-busy iw-in" role="status">';
    if (paid.kind === 'failed') {
        h += '<h3 class="iw-h">' + esc(t('offer_title')) + '</h3><p class="iw-sub">' + esc(t('paid_failed')) + '</p>'
            + '<div class="iw-acts"><button type="button" class="tc-btn" data-act="paid-retry">' + esc(t('paid_retry')) + '</button></div>';
    } else {
        h += '<div class="iw-spin" aria-hidden="true"></div><p class="iw-sub">' + esc(t('paid_pending')) + '</p>';
    }
    el.sideBody.innerHTML = h + '</div>';
    setFoot('');
}
// The text the grade belongs to: an empty sheet (another device, the e-mail
// link) takes it; a sheet with other words keeps them, and the report says it
// belongs to the previous version — the person's work is not overwritten.
function restoreText(j) {
    var snap = { essay: j.essay || el.ta.value, q: j.question || el.q.value, task: j.task_type || S.task };
    if (typeof j.essay === 'string' && (!el.ta.value.trim() || el.ta.value.trim() === j.essay.trim())) {
        var filled = !el.ta.value.trim();
        withoutTouch(function () {
            if (j.task_type) setTask(j.task_type, true);
            el.ta.value = j.essay;
            if (typeof j.question === 'string' && !el.q.value.trim()) el.q.value = j.question;
        });
        autosize(); updateMeter(); runAnalysis();
        if (filled) toast(t('paid_restored'), 'info');
        snap = { essay: el.ta.value, q: el.q.value, task: S.task };
    }
    return snap;
}
function dropPaidParams() {
    try {
        var u = new URL(location.href);
        if (!u.searchParams.has('ielts_paid') && !u.searchParams.has('k')) return;
        u.searchParams.delete('ielts_paid'); u.searchParams.delete('k');
        history.replaceState(history.state, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
}
var claimTries = 0;
function claimOrder(ref, token, loud) {
    return fetch(CFG.claimUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ ref: ref, token: token || '' })
    }).then(function (r) { return r.json().then(function (j) { return { s: r.status, j: j }; }); })
      .then(function (res) {
          var j = res.j || {};
          if (res.s === 404 || !j.ok) {
              // Gone (an unpaid order lives two days) — stop asking about it.
              var mine = readOrder();
              if (mine && +mine.ref === +ref) clearOrder();
              if (loud) { paid = null; renderSide(); toast(t('paid_lost')); }
              return;
          }
          track('paid_claim', { status: j.status });
          if (j.status === 'pending') {
              // Not paid (yet): from the cashier — wait for the webhook; a silent
              // check of an old order — nothing to say.
              if (!loud) return;
              paid = { kind: 'pending', ref: ref, token: token };
              setView('report', true); renderSide();
              if (++claimTries < 50) setTimeout(function () { claimOrder(ref, token, true); }, 3000);
              else { paid = null; renderSide(); toast(t('paid_lost')); }
              return;
          }
          dropPaidParams();
          var snap = restoreText(j);
          offerData = null; paid = null;
          if (j.status === 'done' && j.result) {
              setBusy({ t0: Date.now(), snap: snap, order: { ref: ref, token: token } });
              delivered(j.result, snap);
              return;
          }
          if (j.status === 'grading' && j.job) {
              setBusy({ t0: Date.now(), job: j.job, snap: snap, order: { ref: ref, token: token } });
              setView('report', true);
              poll();
              return;
          }
          paid = { kind: 'failed', ref: ref, token: token };
          setView('report', true); renderSide();
      })
      .catch(function () { if (loud) toast(t('err_generic')); });
}
/* Back from the cashier (?ielts_paid=N, the e-mail adds &k=key) or a tab that
   started a purchase earlier: an order paid elsewhere (the bank app, another
   tab) shows up here without asking. */
function paidBoot() {
    var m = /[?&]ielts_paid=(\d+)/.exec(location.search || ''), k = /[?&]k=([0-9a-fA-F-]{36})/.exec(location.search || '');
    var saved = readOrder();
    if (m) {
        var ref = +m[1], token = k ? k[1] : (saved && +saved.ref === ref ? saved.token : '');
        track('paid_return', { mail: k ? 1 : 0 });
        paid = { kind: 'pending', ref: ref, token: token };
        setView('report', true); renderSide();
        claimOrder(ref, token, true);
        return;
    }
    if (saved) claimOrder(saved.ref, saved.token, false);
}

/* The examiner's report. */
function bandRing(b, label) {
    var frac = Math.max(0, Math.min(1, (Number(b) || 0) / 9)), C = 2 * Math.PI * 36;
    return '<div class="iw-bandbox"><div class="iw-band" style="--iw-c:' + bandColor(b) + '"><svg viewBox="0 0 84 84" aria-hidden="true"><circle class="bg" cx="42" cy="42" r="36"/>'
        + '<circle class="fg" cx="42" cy="42" r="36" stroke-dasharray="' + C.toFixed(2) + '" stroke-dashoffset="' + (C * (1 - frac)).toFixed(2) + '"/></svg>'
        + '<div class="iw-band-n"><b>' + esc(fmtBand(b)) + '</b></div></div>'
        + (label ? '<span class="iw-band-cap">' + esc(label) + '</span>' : '') + '</div>';
}
function expl(en, local) {
    if (LOCALE === 'en' || !local) return esc(en);
    return view.explEn ? esc(en) : esc(local);
}
function reportTabs(rep, issues) {
    var full = rep.depth === 'full';
    var left = issues.filter(function (x) { return !x.done; }).length;
    var tabs = [['criteria', t('tab_criteria')], ['fixes', t('tab_fixes') + (issues.length ? '<span class="n">' + left + '</span>' : '')]];
    if (full) tabs.push(['plan', t('tab_plan')], ['rewrite', t('tab_rewrite')]);
    // The instant check as a compact tab: «⚡ 4» — the count says whether it is
    // worth opening, the name lives in the tooltip and for screen readers.
    var nf = analysis && analysis.findings ? analysis.findings.length : 0;
    tabs.push(['check', '<span aria-hidden="true">⚡</span>' + (nf ? '<span class="n">' + nf + '</span>' : ''), t('tab_check')]);
    if (!tabs.some(function (x) { return x[0] === view.tab; })) view.tab = 'criteria';
    return '<div class="tc-seg iw-tabs" role="tablist">' + tabs.map(function (x) {
        var on = x[0] === view.tab;
        return '<button type="button" role="tab" class="tc-seg-b' + (on ? ' on' : '') + '" aria-selected="' + on + '" data-tab="' + x[0] + '"'
            + (x[2] ? ' title="' + esc(x[2]) + '" aria-label="' + esc(x[2]) + '"' : '') + '>' + x[1] + '</button>';
    }).join('') + '</div>';
}
function renderReport(rep, o) {
    var task = o.example ? (example.data.task || 'task2') : (S.reportTask || S.task);
    var issues = aiIssues();
    var edited = !o.example && S.reportFor && el.ta.value !== S.reportFor;
    var meta = t('report_meta', { time: new Date(o.example ? Date.now() : (S.reportAt || Date.now())).toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' }), n: rep.word_count || A.wordCount(S.reportFor || el.ta.value) });
    var delta = '';
    if (!o.example && typeof S.prevBand === 'number' && typeof rep.overall === 'number') {
        var d = Math.round((rep.overall - S.prevBand) * 10) / 10;
        delta = d > 0 ? '<span class="iw-delta up">' + esc(t('delta_up', { d: d.toFixed(1) })) + '</span>'
            : d < 0 ? '<span class="iw-delta down">' + esc(t('delta_down', { d: Math.abs(d).toFixed(1) })) + '</span>'
            : '<span class="iw-delta">' + esc(t('delta_same')) + '</span>';
    }
    var head = '';
    if (o.example) head += '<div class="iw-ex"><span>' + esc(t('example_banner')) + '</span><button type="button" class="iw-mini" data-act="example-close">' + esc(t('example_back')) + '</button></div>';
    // The head stays short — band, criteria at a glance, when — so the tabs and
    // their content keep the panel; the examiner's summary opens the Criteria tab.
    var mini = '';
    ['task', 'coherence', 'lexical', 'grammar'].forEach(function (k) {
        var c = rep.criteria && rep.criteria[k];
        if (c) mini += '<span class="iw-mini-c"><span>' + esc(critShort(k, task)) + '</span><b style="color:' + bandColor(c.band) + '">' + esc(c.band) + '</b></span>';
    });
    head += '<div class="iw-rep-head' + (redraw ? '' : ' iw-in') + '">' + bandRing(rep.overall, t('overall_label'))
        + '<div class="iw-rep-sum"><div class="iw-minis">' + mini + '</div><div class="iw-meta">' + esc(meta) + (delta ? ' · ' + delta : '') + '</div>'
        + (LOCALE !== 'en' ? '<label class="iw-switch"><input type="checkbox" data-expl' + (view.explEn ? ' checked' : '') + '> ' + esc(t('lang_toggle')) + '</label>' : '')
        + '</div></div>';
    if (edited) head += '<div class="iw-flag">' + esc(t('edited_note')) + '</div>';
    head += reportTabs(rep, issues);
    setHead(head);

    var h = '';
    var IN = redraw ? '' : ' iw-in';
    if (view.tab === 'criteria') {
        if (rep.summary_en || rep.summary_local) h += '<p class="iw-summary">' + expl(rep.summary_en, rep.summary_local) + '</p>';
        if (rep.under_length) h += '<div class="iw-flag">' + esc(t('under_length_warn')) + '</div>';
        if (rep.off_topic) h += '<div class="iw-flag">' + esc(t('off_topic_warn')) + '</div>';
        var lowest = null;
        ['task', 'coherence', 'lexical', 'grammar'].forEach(function (k) { var c = rep.criteria && rep.criteria[k]; if (c && (!lowest || c.band < rep.criteria[lowest].band)) lowest = k; });
        ['task', 'coherence', 'lexical', 'grammar'].forEach(function (k) {
            var c = rep.criteria && rep.criteria[k];
            if (!c) return;
            var isOpen = view.openCrit[k] != null ? view.openCrit[k] : k === lowest;
            h += '<details class="iw-crit' + IN + '" data-crit="' + k + '"' + (isOpen ? ' open' : '') + '><summary><span class="iw-pill">' + esc(critShort(k, task)) + '</span>'
                + '<span class="iw-crit-n">' + esc(critName(k, task)) + '</span><span class="iw-crit-b" style="color:' + bandColor(c.band) + '">' + esc(c.band) + '</span>'
                + '<span class="iw-crit-bar" aria-hidden="true"><i style="width:' + Math.round((c.band / 9) * 100) + '%;--iw-c:' + bandColor(c.band) + '"></i></span></summary>'
                + '<div class="iw-crit-body"><p>' + expl(c.assessment_en, c.assessment_local) + '</p>'
                + (c.evidence_quote ? '<button type="button" class="iw-quote" data-quote="' + esc(k) + '">' + esc(t('evidence_label')) + ' <bdi dir="ltr">“' + esc(c.evidence_quote) + '”</bdi></button>' : '')
                + '</div></details>';
        });
        h += '<p class="iw-disc">' + esc(t('disclaimer')) + '</p>';
    } else if (view.tab === 'fixes') {
        if (!issues.length) h += '<p class="iw-sub">' + esc(t('fixes_empty')) + '</p>';
        else {
            var left = issues.filter(function (x) { return !x.done; }).length;
            h += '<p class="iw-sub">' + esc(t('fixes_left', { n: left, all: issues.length })) + '</p>';
            issues.forEach(function (x) {
                var it = x.item, fv = fixView(it);
                // «Заменить» sits beside the card, not inside it: the card itself is a button
                h += '<div class="iw-fix-w"><div class="iw-fix' + IN + (x.done ? ' done' : '') + '" data-fix="' + x.i + '" tabindex="0" role="button">'
                    + '<div class="iw-fix-h"><span class="iw-pill">' + esc(critShort(it.category, task)) + '</span>' + (x.done ? '<span class="iw-done">✓ ' + esc(t('fix_done')) + '</span>' : '') + '</div>'
                    + fixBody(it, fv)
                    + '</div>'
                    + (fv && !x.done && !o.example ? '<button type="button" class="iw-mini iw-fix-apply" data-fixapply="' + x.i + '">' + esc(t('fix_apply')) + '</button>' : '')
                    + '</div>';
            });
        }
    } else if (view.tab === 'plan') {
        if (rep.boundary_plan && rep.boundary_plan.length) {
            h += '<h4 class="iw-grp-h">' + esc(t('plan_title')) + '</h4><ol class="iw-plan">';
            rep.boundary_plan.forEach(function (p) { h += '<li><b>' + esc(p.target) + '</b> — ' + expl(p.move_en, p.move_local) + '</li>'; });
            h += '</ol>';
        }
        if (rep.drills && rep.drills.length) {
            h += '<div class="iw-grp"><h4 class="iw-grp-h">' + esc(t('drills_title')) + '</h4><ol class="iw-plan">';
            rep.drills.forEach(function (d) { h += '<li>' + (d.criterion ? '<span class="iw-pill">' + esc(critShort(d.criterion, task)) + '</span> ' : '') + expl(d.drill_en, d.drill_local) + '</li>'; });
            h += '</ol></div>';
        }
    } else if (view.tab === 'rewrite') {
        var diffOn = !!setting('diff', false);
        var base = o.example ? example.data.essay : (S.reportFor || '');
        h += '<p class="iw-sub">' + esc(t('rewrite_hint')) + '</p><div class="iw-rw-bar"><label class="iw-switch"><input type="checkbox" data-diff' + (diffOn ? ' checked' : '') + '> ' + esc(t('diff_toggle')) + '</label>'
            + '<button type="button" class="iw-mini" data-act="copy-rewrite">' + esc(t('copy_rewrite')) + '</button></div>'
            + '<div class="iw-rw">' + (diffOn && base ? markChange(base, rep.band9_rewrite || '') : esc(rep.band9_rewrite || '')) + '</div>';
    } else {
        h += checkHTML();
    }
    el.sideBody.innerHTML = h;
    var foot = '';
    if (!o.example) foot += '<button type="button" class="tc-btn ghost sm" data-act="pdf">' + esc(t('pdf_btn')) + '</button><button type="button" class="tc-btn ghost sm" data-act="copy">' + esc(t('copy_btn')) + '</button>';
    setFoot(foot);
}

/* side panel interactions */
el.sideHead.addEventListener('click', function (e) {
    var tb = e.target.closest('[data-tab]');
    if (tb) { view.tab = tb.getAttribute('data-tab'); renderSide(); track('tab', { tab: view.tab }); return; }
    var a = e.target.closest('[data-act]');
    if (a) onAct(a.getAttribute('data-act'), a);
});
el.sideHead.addEventListener('change', function (e) {
    if (e.target.matches('[data-expl]')) { view.explEn = e.target.checked; saveSetting('explEn', view.explEn); renderSide(); track('expl_lang', { en: view.explEn ? 1 : 0 }); }
});
el.sideBody.addEventListener('change', function (e) {
    if (e.target.matches('[data-hltog]')) { view.hl = e.target.checked; saveSetting('hl', view.hl); root.setAttribute('data-hl', view.hl ? 'on' : 'off'); paintHighlights(); }
    if (e.target.matches('[data-diff]')) { saveSetting('diff', e.target.checked); renderSide(); track('diff', { on: e.target.checked ? 1 : 0 }); }
});
var findCycle = {};
el.sideBody.addEventListener('click', function (e) {
    // The cashier (token-wall.js) takes the click first and reads the order
    // from the link when «Pay» is pressed; here the essay is brought up to date.
    var bl = e.target.closest('[data-iw-buy]');
    if (bl) { track('offer_buy', { path: bl.getAttribute('data-iw-buy') }); if (bl.getAttribute('data-iw-buy') !== 'login') ensureOrder().catch(function () {}); }
    var b = e.target.closest('[data-find]');
    if (b && analysis) {
        var i = +b.getAttribute('data-find'), f = analysis.findings[i];
        if (!f || !f.ranges.length) return;
        var k = 'f' + i, n = findCycle[k] = ((findCycle[k] == null ? -1 : findCycle[k]) + 1) % f.ranges.length;
        setView('write', true);
        setFocus([f.ranges[n]], 'focus', k);
        el.sideBody.querySelectorAll('.iw-find.on').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        track('find_show', { id: f.id });
        return;
    }
    var fa = e.target.closest('[data-fixall]');
    if (fa && analysis) {
        var ff = analysis.findings[+fa.getAttribute('data-fixall')];
        if (ff && ff.fixes) { applyFixes(ff.fixes); track('fix_all', { id: ff.id, n: ff.fixes.length }); }
        return;
    }
    var q = e.target.closest('[data-quote]');
    if (q) {
        var rep = example ? example.data.report : S.report, c = rep && rep.criteria && rep.criteria[q.getAttribute('data-quote')];
        if (c && c.evidence_quote) {
            var at = locate(el.ta.value, c.evidence_quote, c.quote_offset);
            if (at >= 0) { setView('write', true); setFocus([[at, at + c.evidence_quote.length]], 'quote', 'q'); }
        }
        track('quote_show');
        return;
    }
    var ap = e.target.closest('[data-fixapply]');
    if (ap) { applyAiFix(+ap.getAttribute('data-fixapply'), 'list'); return; }
    var fx = e.target.closest('[data-fix]');
    if (fx) { showIssue(+fx.getAttribute('data-fix')); return; }
    var a = e.target.closest('[data-act]');
    if (a) onAct(a.getAttribute('data-act'), a);
});
// Which criteria the person opened — kept across redraws.
el.sideBody.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('details[data-crit]')) view.openCrit[d.getAttribute('data-crit')] = d.open;
}, true);
el.sideBody.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-fix]')) { e.preventDefault(); showIssue(+e.target.getAttribute('data-fix')); }
});
el.sideFoot.addEventListener('click', function (e) { var a = e.target.closest('[data-act]'); if (a) onAct(a.getAttribute('data-act'), a); });
function showIssue(i) {
    var x = aiIssues()[i];
    el.sideBody.querySelectorAll('.iw-fix.on').forEach(function (n) { n.classList.remove('on'); });
    var card = el.sideBody.querySelector('[data-fix="' + i + '"]');
    if (card) card.classList.add('on');
    if (x && !x.done) { setView('write', true); setFocus([[x.s, x.e]], 'focus', 'ai' + i); }
    track('issue_show');
}
function onAct(act, btn) {
    if (act === 'example') return openExample();
    if (act === 'example-close') return closeExample();
    if (act === 'mock') return randomQuestion(true);
    if (act === 'tokens') return grade(true);
    if (act === 'polar-buy') return buyPolar(btn);
    if (act === 'paid-retry') { if (paid) { var pr = paid; paid = { kind: 'pending', ref: pr.ref, token: pr.token }; renderSide(); claimOrder(pr.ref, pr.token, true); } return; }
    if (act === 'pdf') return exportPdf(btn);
    if (act === 'copy') return copyReport();
    if (act === 'copy-rewrite') {
        var rep = example ? example.data.report : S.report;
        copyText(rep && rep.band9_rewrite || '');
        track('copy_rewrite');
    }
}
document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-offer-cta]')) track('offer_click');
});

/* ═══ example report ═════════════════════════════════════════════════════ */
function snapshot() { return { essay: el.ta.value, q: el.q.value, task: S.task, qid: S.qid, chart: S.chart }; }
function openExample() {
    if (example) return;
    track('example_open');
    fetch(CFG.exampleUrl, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('example ' + r.status); return r.json(); })
        .then(function (d) {
            if (!d || !d.report || !d.essay) throw new Error('example shape');
            example = { data: d, saved: snapshot() };
            offerData = null;
            withoutTouch(function () {
                el.ta.value = d.essay;
                el.q.value = d.question || '';
                setTask(d.task || 'task2', true);
                S.qid = ''; S.chart = null; renderChart();
            });
            el.ta.readOnly = true; el.q.readOnly = true;
            autosize(); updateMeter();
            view.tab = 'criteria';
            setView('report');
            runAnalysis();
        })
        .catch(function () { toast(t('example_failed')); });
}
function closeExample() {
    if (!example) return;
    var s = example.saved;
    example = null;
    withoutTouch(function () {
        el.ta.readOnly = false; el.q.readOnly = false;
        el.ta.value = s.essay; el.q.value = s.q;
        setTask(s.task, true);
        S.qid = s.qid; S.chart = s.chart; renderChart();
    });
    autosize(); updateMeter();
    focus = null;
    setView('write');
    runAnalysis();
    updateGoButton();
}

/* ═══ copy & PDF ═════════════════════════════════════════════════════════ */
function copyText(s) {
    function done() { toast(t('copied'), 'success'); }
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(s).then(done, legacy); return; }
    } catch (e) {}
    legacy();
    function legacy() {
        var ta = document.createElement('textarea');
        ta.value = s; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
    }
}
function reportText(rep) {
    var task = S.reportTask || S.task, L = [];
    L.push(t('overall_label') + ': ' + fmtBand(rep.overall));
    ['task', 'coherence', 'lexical', 'grammar'].forEach(function (k) {
        var c = rep.criteria && rep.criteria[k]; if (!c) return;
        L.push('', critName(k, task) + ': ' + c.band, c.assessment_en);
        if (c.assessment_local && LOCALE !== 'en') L.push(c.assessment_local);
        if (c.evidence_quote) L.push('“' + c.evidence_quote + '”');
    });
    if (rep.summary_en) L.push('', t('summary_label') + ':', rep.summary_en, rep.summary_local && LOCALE !== 'en' ? rep.summary_local : '');
    if (rep.inline_issues && rep.inline_issues.length) {
        L.push('', t('issues_title') + ':');
        rep.inline_issues.forEach(function (it) { L.push('- ' + it.quote + ' → ' + it.fix_en); });
    }
    if (rep.boundary_plan && rep.boundary_plan.length) {
        L.push('', t('plan_title') + ':');
        rep.boundary_plan.forEach(function (p) { L.push('- ' + p.target + ': ' + p.move_en); });
    }
    if (rep.band9_rewrite) L.push('', t('rewrite_title') + ':', rep.band9_rewrite);
    L.push('', t('disclaimer'));
    return L.filter(function (x) { return x != null; }).join('\n');
}
function copyReport() { if (S.report) { copyText(reportText(S.report)); track('copy'); } }
function exportPdf(btn) {
    var rep = S.report;
    if (!rep) return;
    var task = S.reportTask || S.task;
    var d = new Date(S.reportAt || Date.now());
    var h = '<div style="display:flex;justify-content:space-between;align-items:baseline;border-bottom:2px solid #d0d7de;padding-bottom:8px;margin-bottom:14px">'
        + '<strong style="font-size:16px">' + esc(CFG.brand || '') + '</strong><span class="pm">' + esc(d.toLocaleString(LOCALE)) + '</span></div>'
        + '<h1>' + esc(t('pdf_title')) + '</h1><div class="pm">' + esc((T['task' + (task === 'task2' ? '2' : task === 'task1_gt' ? '1_gt' : '1_academic')] || task) + ' · ' + t('report_meta', { time: d.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' }), n: rep.word_count || 0 })) + '</div>'
        + '<table><tr><th>' + esc(t('overall_label')) + '</th><td class="pb">' + esc(fmtBand(rep.overall)) + '</td></tr>';
    ['task', 'coherence', 'lexical', 'grammar'].forEach(function (k) { var c = rep.criteria && rep.criteria[k]; if (c) h += '<tr><th>' + esc(critName(k, task)) + '</th><td><b>' + esc(c.band) + '</b></td></tr>'; });
    h += '</table>';
    if (rep.summary_en) h += '<h2>' + esc(t('summary_label')) + '</h2><p>' + esc(rep.summary_en) + '</p>' + (rep.summary_local && LOCALE !== 'en' ? '<p class="pm">' + esc(rep.summary_local) + '</p>' : '');
    ['task', 'coherence', 'lexical', 'grammar'].forEach(function (k) {
        var c = rep.criteria && rep.criteria[k]; if (!c) return;
        h += '<h2>' + esc(critName(k, task)) + ' — ' + esc(c.band) + '</h2><p>' + esc(c.assessment_en) + '</p>'
            + (c.assessment_local && LOCALE !== 'en' ? '<p class="pm">' + esc(c.assessment_local) + '</p>' : '')
            + (c.evidence_quote ? '<blockquote>“' + esc(c.evidence_quote) + '”</blockquote>' : '');
    });
    if (rep.inline_issues && rep.inline_issues.length) {
        h += '<h2>' + esc(t('issues_title')) + '</h2><table>';
        rep.inline_issues.forEach(function (it) {
            var c = A.correction(it.quote, it.fix_en);
            if (!c) {
                h += '<tr><td class="pq">' + esc(it.quote) + '</td><td>' + esc(it.fix_en) + (it.fix_local && LOCALE !== 'en' ? '<div class="pm">' + esc(it.fix_local) + '</div>' : '') + '</td></tr>';
                return;
            }
            h += '<tr><td class="pd">' + markChange(it.quote, c.text) + '</td><td>' + esc(c.why) + (it.fix_local && LOCALE !== 'en' ? '<div class="pm">' + esc(A.correctionReason(it.fix_local)) + '</div>' : '') + '</td></tr>';
        });
        h += '</table>';
    }
    if (rep.boundary_plan && rep.boundary_plan.length) {
        h += '<h2>' + esc(t('plan_title')) + '</h2><ol>';
        rep.boundary_plan.forEach(function (p) { h += '<li><b>' + esc(p.target) + '</b> — ' + esc(p.move_en) + (p.move_local && LOCALE !== 'en' ? '<div class="pm">' + esc(p.move_local) + '</div>' : '') + '</li>'; });
        h += '</ol>';
    }
    if (rep.drills && rep.drills.length) {
        h += '<h2>' + esc(t('drills_title')) + '</h2><ol>';
        rep.drills.forEach(function (x) { h += '<li>' + esc(x.drill_en) + (x.drill_local && LOCALE !== 'en' ? '<div class="pm">' + esc(x.drill_local) + '</div>' : '') + '</li>'; });
        h += '</ol>';
    }
    if (S.reportQ) h += '<h2>' + esc(t('pdf_question')) + '</h2><pre>' + esc(S.reportQ) + '</pre>';
    if (S.reportFor) h += '<h2>' + esc(t('pdf_essay')) + '</h2><pre>' + esc(S.reportFor) + '</pre>';
    if (rep.band9_rewrite) h += '<h2>' + esc(t('rewrite_title')) + '</h2><pre>' + esc(rep.band9_rewrite) + '</pre>';
    h += '<p class="pm" style="margin-top:18px">' + esc(t('disclaimer')) + '</p>';
    el.pdfDoc.innerHTML = h;
    if (btn) btn.disabled = true;
    var run = function () {
        window.__generatePDF({ element: el.pdfDoc, filename: 'ielts-writing-report.pdf', strings: { libError: t('pdf_failed'), genError: t('pdf_failed') } })
            .then(function (r) { if (btn) btn.disabled = false; track('pdf', { ok: r && r.ok ? 1 : 0 }); });
    };
    if (window.__generatePDF) return run();
    var s = document.createElement('script');
    // Versioned URL: /js is served immutable for 180 days (RuntimeScriptVersioningTest).
    s.src = (typeof window.__jsSrc === 'function') ? window.__jsSrc('/js/report-pdf.js') : '/js/report-pdf.js';
    s.onload = function () { if (window.__generatePDF) run(); else { if (btn) btn.disabled = false; toast(t('pdf_failed')); } };
    s.onerror = function () { if (btn) btn.disabled = false; toast(t('pdf_failed')); };
    document.head.appendChild(s);
}

/* ═══ a report from «My generations» (?report=ID) ═════════════════════════ */
function openLibraryReport(id) {
    fetch(CFG.libraryUrl + '/' + encodeURIComponent(id), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (rep) {
            if (!rep || !rep.criteria) throw new Error('shape');
            withoutTouch(function () {
                if (rep.task_type) setTask(rep.task_type, true);
                if (typeof rep.essay === 'string' && !el.ta.value.trim()) { el.ta.value = rep.essay; }
                if (typeof rep.question === 'string' && !el.q.value.trim()) { el.q.value = rep.question; }
            });
            autosize(); updateMeter();
            S.report = rep; S.reportFor = typeof rep.essay === 'string' ? rep.essay : el.ta.value;
            S.reportQ = rep.question || ''; S.reportTask = rep.task_type || S.task; S.reportAt = rep.graded_at ? Date.parse(rep.graded_at) || Date.now() : Date.now();
            view.side = 'report'; view.tab = 'criteria';
            setView('report');
            runAnalysis(); updateGoButton();
            track('library_open');
        })
        .catch(function () { toast(t('err_report_gone')); });
}

/* ═══ saved essays («My essays») ═════════════════════════════════════════ */
var quiet = 0;
function withoutTouch(fn) { quiet++; try { fn(); } finally { quiet--; } }
function touch() { if (ed && !quiet && !example) { try { ed.touch(true); } catch (e) {} } }
function currentState() {
    var src = example ? example.saved : null;
    return {
        v: 1, task: src ? src.task : S.task, question: src ? src.q : el.q.value, qid: src ? src.qid : S.qid,
        essay: src ? src.essay : el.ta.value, report: S.report, reportFor: S.reportFor, reportQ: S.reportQ, reportTask: S.reportTask,
        reportAt: S.reportAt, history: S.history, prevBand: S.prevBand == null ? null : S.prevBand, timer: S.timer
    };
}
function labelFor(st) {
    var first = (String(st.question || '').split(/\n/)[0] || String(st.essay || '').split(/\n/)[0] || '').trim();
    var band = st.report && typeof st.report.overall === 'number' ? fmtBand(st.report.overall) + ' · ' : '';
    return (band + first).slice(0, 90);
}
function applyState(st, files) {
    st = st || {};
    var missing = [];
    withoutTouch(function () {
        el.ta.readOnly = false; el.q.readOnly = false;
        el.ta.value = typeof st.essay === 'string' ? st.essay : '';
        el.q.value = typeof st.question === 'string' ? st.question : '';
        setTask(st.task || 'task2', true);
        S.qid = st.qid || ''; S.chart = null; S.upload = null;
        S.report = st.report || null; S.reportFor = st.reportFor || ''; S.reportQ = st.reportQ || ''; S.reportTask = st.reportTask || S.task;
        S.reportAt = st.reportAt || 0; S.history = Array.isArray(st.history) ? st.history : []; S.prevBand = st.prevBand == null ? null : st.prevBand;
        S.timer = (st.timer && typeof st.timer === 'object') ? { limit: st.timer.limit || 0, start: st.timer.start || 0, acc: st.timer.acc || 0, run: !!st.timer.run } : { limit: 0, start: 0, acc: 0, run: false };
    });
    if (S.qid) loadBank().then(function () { var it = findBankItem(S.qid); if (it) { S.chart = it.chart || null; renderChart(); } }, function () {});
    var f = (files || [])[0];
    if (f && S.task === 'task1_academic') {
        var r = new FileReader();
        r.onload = function () { var d = String(r.result || ''), i = d.indexOf(','); S.upload = { blob: f, name: f.name || 'chart', media: f.type || 'image/png', data: i >= 0 ? d.slice(i + 1) : '' }; };
        r.readAsDataURL(f);
    }
    clearInterval(timerIv);
    if (S.timer.run) { spell(false); timerIv = setInterval(renderTimer, 500); } else spell(!(S.timer.acc > 0));
    renderTimer();
    renderChart();
    offerData = null; focus = null;
    view.side = 'auto'; view.tab = 'criteria';
    autosize(); updateMeter(); updateGoButton();
    runAnalysis();
    return missing;
}
function draftsBoot() {
    if (!window.__toolDraft || !window.__toolDraft.editor || !$('iwDrafts')) return;
    ed = window.__toolDraft.editor({
        slug: SLUG, root: 'iwDrafts', icon: '📝',
        payload: function () {
            var st = currentState();
            if (!String(st.essay || '').trim() && !String(st.question || '').trim()) return null;
            return {
                state: st,
                files: (S.upload && S.upload.blob) ? [S.upload.blob] : [],
                label: labelFor(st),
                meta: { band: st.report && typeof st.report.overall === 'number' ? st.report.overall : null, words: A.wordCount(st.essay) }
            };
        },
        apply: function (d) { return Promise.resolve(applyState(d && d.state, d && d.files)); },
        fresh: function () { if (example) closeExample(); applyState({}); },
        started: function () { return !!(el.ta.value.trim() || el.q.value.trim()); }
    });
    try { ed.boot(); } catch (e) {}
}

/* ═══ boot ═══════════════════════════════════════════════════════════════ */
function boot() {
    // On a narrow screen «New essay» is only «＋» — keep its name on hover.
    var nb = $('iwDraftsNew');
    if (nb && !nb.title) nb.title = String(nb.textContent || '').replace(/^\s*＋\s*/, '').trim();
    plainMirror();
    autosize();
    setTask('task2', true);
    updateMeter();
    renderTimer();
    updateGoButton();
    draftsBoot();
    resumePendingJob();
    if (!busy) paidBoot();
    if (CFG.report) openLibraryReport(CFG.report);
    // The bank is small and the «random question» button should answer at once.
    if ('requestIdleCallback' in window) window.requestIdleCallback(function () { loadBank().catch(function () {}); }, { timeout: 4000 });
    else setTimeout(function () { loadBank().catch(function () {}); }, 2500);
    if (!FIELD_SIZING) window.addEventListener('resize', autosize, { passive: true });
}
boot();
})();
